import React from 'react';
import TodoList from './Components/TodoList'
import './App.css'

function App() {
  return (
    <div className="container-fluid">
      <TodoList />
    </div>
  );
}

export default App;
